<template>
  <MetaButton data-testid="viewer-subheader-collections-item" tooltip="Collection" tooltip-placement="top" @click="addToCollectionAction">
    <Icon :name="iconName" size="sm" />
  </MetaButton>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';
import { computed } from 'vue';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { useItemActions } from '../../composables/useItemActions';
import { useCollectionsStore } from '@/store/useCollectionsStore';
import { useViewerItemStore } from '../../store/useViewerItemStore';

const collectionsStore = useCollectionsStore();
const viewerItemStore = useViewerItemStore();

const { addToCollectionAction } = useItemActions();
const { id } = storeToRefs(viewerItemStore);
const { list } = storeToRefs(collectionsStore);

const hasCollection = () => {
  if (id.value === undefined) {
    return false;
  }

  return list.value ? list.value.filter(col => col.items.includes(id.value || '')).length > 0 : false;
};

const iconName = computed(() => (hasCollection() ? 'general.folderFull' : 'general.folder'));
</script>
